<template>
  <div class="page-template">
<!--    <div class="page-title">{{title}}</div>-->
    <div class="page-edit">
      <div class="title-one">
        <div class="circle">●</div>
        <div class="word">开通储值</div>
      </div>
      <div class="state">
        <span>当前状态</span>
        <span class="state-two">已开通</span>
        <el-button>立即关闭</el-button>
      </div>
      <div class="section">
        <ul>
          <li>储值业务，是指利用会员的储值的账户进行充值和消费的一种会员营销和快速支付的业务。嘉维斯的储值业务，将给您提供充值、消费、报表查询等业务功能。同时，还为了您的安全做了考虑。</li>
          <li>1、储值业务的开通需要进行验证，以确保是在您的操作下开通的。</li>
          <li>2、处置业务可控制在指定的电脑或平板上进行。</li>
          <li>3、可指定操作员来进行充值。</li>
          <li>4、可指定的会员类别开通储值功能。</li>
          <li>储值业务请严格管理，以使您能安全的开展储值业务。注意保管好管理员的密码。并留意业务开通授权的短信</li>
        </ul>
      </div>
      <div class="cipher">
        <p>RF读卡器M1卡读写密码</p><input type="text"><el-button>修改密码</el-button>
      </div>
      <div class="section">
        <ul>
          <li>提示：RF读卡器M1卡读写密码只能填写12位16进制的字符（可以是数字0~9，字母a~f或A~F）。</li>
          <li>警告：修改此项会造成已经发出去的卡无法正常使用，请谨慎操作！</li>
        </ul>
      </div>
      <div class="title-two">
        <div class="circle">●</div>
        <div class="word">其他设置</div>
      </div>
      <div class="list">
        <div class="list-box">
          <el-switch v-model="value1" active-color="#5f58e6" inactive-color="#ececec"></el-switch>
          <div class="text">每天限用充值卡次数</div>
          <input type="text" style="text-align:center" >
          次
        </div>
        <div class="list-box">
          <el-switch v-model="value2" active-color="#5f58e6" inactive-color="#ececec"></el-switch>
          <div class="text">每单储值卡付款限额</div>
          <input type="text" style="text-align:center" >
          元
        </div>
        <div class="list-box">
          <el-switch v-model="value3" active-color="#5f58e6" inactive-color="#ececec"></el-switch>
          <div class="text">支持储值卡多卡付款</div>
        </div>
        <div class="list-box">
          <el-switch v-model="value4" active-color="#5f58e6" inactive-color="#ececec"></el-switch>
          <div class="text">是否允许手工赠送（非储值赠送规则外）最大赠送金额</div>
          <input type="text" style="text-align:center" >
          元
        </div>
        <div class="list-box">
          <el-switch v-model="value5" active-color="#5f58e6" inactive-color="#ececec"></el-switch>
          <div class="text">充值卡充值时允许为负数</div>
        </div>
        <div class="list-box">
          每<input type="text" style="text-align:center" >积分转换成<input type="text" style="text-align:center" >元储值额
        </div>
      </div>
      <form-template ref="formTemplate">
      </form-template>
    </div>
  </div>
</template>
<script>
  import formTemplate from "@/components/template/formTemplate";

  export default {
    components: {
      formTemplate,
    },
    data() {
      return {
        title: '',
        value1: true,
        value2: true,
        value3: true,
        value4: true,
        value5: true,
      };
    },
    mounted() {
      this.title = document.title;
    },
  };
</script>

<style scoped>
.page-template{
  /* height: calc(100vh - 62px); */
  /*background:#ddd;*/
  padding: 22px 18px;
  font-size: 14px;
}
.page-edit{
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 10px;
}
.title-one{
  position: relative;
  margin-left: 20px;
}
.circle{
  color: #5e57e3;
  position: absolute;
  margin-left: -20px;
}
.word{
  font-weight: bold;
  font-size: 16px;
}
.state{
  margin-left: 20px;
  margin-top: 10px;
  display: flex;
}
.state span{
  padding-top: 5px;
}
.state-two{
  margin-left: 20px;
}
.state button{
  margin-left: 20px;
}
.section{
  margin-left: 20px;
  background-color: #fdf6ec;
  margin-top: 30px;
}
.section ul{
  padding: 10px 0 10px 10px;
}
.section ul li{
  color: #e8a565;
}
.cipher{
  display: flex;
  margin: 20px 0 0 20px;
}
.cipher p{
  padding-top: 5px;
}
.cipher input{
  margin: 0 20px;
  color: #ddd;
  width: 300px;
  height: 30px;
}
.title-two{
  position: relative;
  margin: 20px 0 0 20px;
}
.list{
  margin-left: 20px;
}
.list .list-box{
  display: flex;
  margin: 10px 0 10px 0;
}
.list .list-box .text{
  margin-left: 10px;
}
.list .list-box input{
  width: 60px;
  margin: 0 5px 0 5px;
}
</style>>



// WEBPACK FOOTER //
// src/page/member/ecard/Setting.vue